import { useContext, useState } from "react";
import PopupContext from "../../../context/context-popup";

import SidePopup from "../../../components/side-popup";
import List from "../../../components/list";
import InputsTextArea from "../../../components/inputs/inputs-text-area";
import { ButtonCancel, ButtonModify, ButtonRemove, ButtonSave } from "../../../components/buttons";
import meetingsApi from "../../../lib/meetings/meetings-api";
import InputsText from "../../../components/inputs/inputs-text";
import ContentDropdown from "../../../components/content-dropdown";
import LabelContainer from "../../../components/label-container";
import Container from "../../../layouts/containers/container";
import Row from "../../../components/row";
import InputsCheckbox from "../../../components/inputs/inputs-checkbox";

import { toast } from 'react-toastify';
import ErrorContainer from "../../../components/error-container";

import SidePopupSection from "../../../components/side-popup/section";
import { stringToFriendlyDatetime } from "../../../lib/helpers/datetime-helpers";
import Grid from "../../../components/grid";

import Divider from "../../../components/divider/divider";

export default function PopupsViewReceipt({ details, relation }) {
    const quote = details;

    const line_items = quote?.saved_quote_line_items || quote?.receipt_line_items;

    const getLineItem = (relatedTo) => {
        const lineItems = quote?.saved_quote_line_items;

        const item  = lineItems?.find(l => l.related_to = relatedTo);

        return item || {};
    }

    let url = `${relation?.url}/${quote?.related_id}`;

    if (relation?.name === 'Event Booking') {
        url = `/events/${quote?.meta?.event?.id}/bookings/${quote?.related_id}`
    }

    if (relation?.name === 'Meeting Room Booking Version') {
        url = `${relation?.url}/${getLineItem("App\\Models\\MeetingRoomBooking")?.related_id}`;
    }
   
    return (
        <SidePopup title="Receipt">
            <List gap='40px'>
                <SidePopupSection title="General Details">
                    <Container gap="20px">
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, minmax(0px, 1fr))',
                            gap: '20px'
                        }}>
                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Gross Price</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">£{ quote?.gross_price }</Container.Text>
                                </Container.Content>
                            </Container>

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Discount</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">£{ quote?.discount }</Container.Text>
                                </Container.Content>
                            </Container>

                             <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Total Price</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">£{ quote?.total }</Container.Text>
                                </Container.Content>
                            </Container>

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Credits Used</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">{ quote?.credits_used }</Container.Text>
                                </Container.Content>
                            </Container>

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Relation</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">
                                        <a href={url}>{ relation?.name }</a>
                                    </Container.Text>
                                </Container.Content>
                            </Container>

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Created At</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">{ stringToFriendlyDatetime(quote?.created_at) }</Container.Text>
                                </Container.Content>
                            </Container>

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Updated At</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">{ stringToFriendlyDatetime(quote?.updated_at) }</Container.Text>
                                </Container.Content>
                            </Container>
                        </div>
                    </Container>
                </SidePopupSection>

                <SidePopupSection title="Billing">
                    <Container gap="20px">
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, minmax(0px, 1fr))',
                            gap: '20px'
                        }}>
                            { quote?.billing_profile?.billable_type === "App\\Models\\User" ? 
                                <Container style={{flex: '1 0 0'}}>
                                    <Container.Header>
                                        <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Name</Container.Title>
                                    </Container.Header>
                                    <Container.Content>
                                        <Container.Text fontSize="16px">{ quote?.billing_profile?.name }</Container.Text>
                                    </Container.Content>
                                </Container>
                            :                          
                                <>
                                    <Container style={{flex: '1 0 0'}}>
                                        <Container.Header>
                                            <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">First Name</Container.Title>
                                        </Container.Header>
                                        <Container.Content>
                                            <Container.Text fontSize="16px">{ quote?.billing_profile?.first_name }</Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container style={{flex: '1 0 0'}}>
                                        <Container.Header>
                                            <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Last Name</Container.Title>
                                        </Container.Header>
                                        <Container.Content>
                                            <Container.Text fontSize="16px">{ quote?.billing_profile?.last_name }</Container.Text>
                                        </Container.Content>
                                    </Container>
                                </>
                            }

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Email Address</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">{ quote?.billing_profile?.email_address }</Container.Text>
                                </Container.Content>
                            </Container>

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Company Name</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">{ quote?.billing_profile?.company_name }</Container.Text>
                                </Container.Content>
                            </Container>

                            <Container style={{flex: '1 0 0'}}>
                                <Container.Header>
                                    <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">SAP Number</Container.Title>
                                </Container.Header>
                                <Container.Content>
                                    <Container.Text fontSize="16px">{ quote?.billing_profile?.sap_number }</Container.Text>
                                </Container.Content>
                            </Container>
                        </div>
                    </Container>
                </SidePopupSection>

                <SidePopupSection title="Line Items">
                    <List gap="20px" divider={<Divider top="10px" bottom="10px"/>}>
                        { line_items?.map((item, index) => {
                            return (
                                <List key={index} gap="20px">
                                    <Container style={{flex: '1 0 0'}}>
                                        <Container.Header>
                                            <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Description</Container.Title>
                                        </Container.Header>
                                        <Container.Content>
                                            <Container.Text fontSize="16px">{ item?.description }</Container.Text>
                                        </Container.Content>
                                    </Container>
                                    
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(3, minmax(0px, 1fr))',
                                        gap: '20px'
                                    }}>
                                        <Container style={{flex: '1 0 0'}}>
                                            <Container.Header>
                                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Quantity</Container.Title>
                                            </Container.Header>
                                            <Container.Content>
                                                <Container.Text fontSize="16px">{ item?.quantity }</Container.Text>
                                            </Container.Content>
                                        </Container>

                                        <Container style={{flex: '1 0 0'}}>
                                            <Container.Header>
                                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Total</Container.Title>
                                            </Container.Header>
                                            <Container.Content>
                                                <Container.Text fontSize="16px">£{ item?.total }</Container.Text>
                                            </Container.Content>
                                        </Container>

                                        <Container style={{flex: '1 0 0'}}>
                                            <Container.Header>
                                                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">Credits Used</Container.Title>
                                            </Container.Header>
                                            <Container.Content>
                                                <Container.Text fontSize="16px">{ item?.credits_used }</Container.Text>
                                            </Container.Content>
                                        </Container>
                                    </div>
                                </List>
                            )
                        })}
                    </List>
                </SidePopupSection>
            </List>
        </SidePopup>
    )   
}